import { isToBeReviewedPickup } from '../../../../../../modules/Dispatch/RouteExecution/filterUtils';
import { sortByTimestampDesc } from '../../../../../../common/utils/dateTimeUtils';
import { NOTIFICATION_TYPES } from '../../../constants';
import { getDriverDisplayForPickup } from './getDriverDisplayForPickup';

type PickupRow = {
  pickupId: string;
  pickupNumber: string;
  shipperName?: string;
  prevAssignedDriver?: string | null;
  lastModifiedDateTime?: string;
  isToBeReviewed?: boolean;
  isVoided?: boolean;
  isMissed?: boolean;
  isNoFreight?: boolean;
};

type DispatchedDriver = {
  driverName?: string;
  driverNumber?: string;
};

export type ToBeReviewedItem = {
  id: string;
  type: typeof NOTIFICATION_TYPES.TO_BE_REVIEWED_PICKUP;
  timestamp: string;
  pickupId: string;
  pickupNumber: string;
  shipperName: string;
  driverDisplay: string;
  /** Set on summary card: other active TBR pickups besides the newest. */
  moreToReviewCount?: number;
  /** All active TBR pickup ids represented by this summary card (for multi-select on click). */
  relatedPickupIds?: string[];
};

const getPickupTimestamp = (pickup: PickupRow) => {
  const timestamp = pickup.lastModifiedDateTime;
  if (!timestamp || Number.isNaN(new Date(timestamp).getTime())) {
    return '';
  }
  return timestamp;
};

/**
 * One notification card per To Be Reviewed pickup.
 */
export const buildToBeReviewed = (
  flatPickups: PickupRow[],
  dispatchedDrivers: DispatchedDriver[] = []
): ToBeReviewedItem[] => {
  const toBeReviewedPickups = flatPickups.filter((pickup) => isToBeReviewedPickup({ pickup }));

  if (!toBeReviewedPickups.length) {
    return [];
  }

  const items: ToBeReviewedItem[] = toBeReviewedPickups.map((pickup) => ({
    id: `pickup-${pickup.pickupId}`,
    type: NOTIFICATION_TYPES.TO_BE_REVIEWED_PICKUP,
    timestamp: getPickupTimestamp(pickup),
    pickupId: pickup.pickupId,
    pickupNumber: pickup.pickupNumber,
    shipperName: pickup.shipperName || '',
    driverDisplay: getDriverDisplayForPickup(pickup.prevAssignedDriver, dispatchedDrivers),
  }));

  return sortByTimestampDesc(items, (item) => item.timestamp);
};
